module.exports = __webpack_public_path__ + "img/mp3.ecdcb773.png";